import styles from "./App.module.css";
import LogoContainer from "./component/LogoContainer/LogoContainer";
import { Box, createTheme, ThemeProvider, Typography } from "@mui/material";
import Routers from "./route/Routers";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import RoutersDelete from "./route/RoutersDelete";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#CF0000",
      },
    },
  });
  const [searchParams] = useSearchParams();
  const pathLocation = useLocation();
  const backUrl = searchParams.get("cancel");
  const isNextPage = searchParams.get("isNextPage");
  const isLastPage = searchParams.get("isLastPage");
  const firstPageUrl = useSelector((state) => state.homepage.firstPageUrl);
  const goBack = () => {
    if (isNextPage) {
      window.history.back();
      return;
    }
    if (isLastPage) {
      window.location.replace(firstPageUrl);
      return;
    }
    window.location.replace(backUrl);
  };
  // const { isLogo } = useSelector((state) => state.homepage);
  // return (
  //   <div className={styles.App}>
  //     <ThemeProvider theme={theme}>
  //       <Box className={styles.appBox}>
  //         {isLogo && (
  //           <>
  //             <div className={styles.headerContainer}>
  //               <a
  //                 style={{ cursor: "pointer", zIndex: 99 }}
  //                 onClick={() => goBack()}
  //               >
  //                 <ArrowBackIcon sx={{ color: "#CF0000", fontSize: "30px" }} />
  //               </a>
  //             </div>
  //             <LogoContainer />
  //           </>
  //         )}
  //         <Routers />
  //       </Box>
  //     </ThemeProvider>
  //   </div>
  // );
  const deleteAcc =
    window.location.href.split("/")[window.location.href.split("/").length - 1];
  if (window.location.href.split("/")[3] === "delete") {
    return (
      <div className={styles.App}>
        <ThemeProvider theme={theme}>
          {deleteAcc ? (
            <RoutersDelete />
          ) : (
            <Box className={styles.appBox}>
              <div className={styles.headerContainer}>
                <a
                  style={{ cursor: "pointer", zIndex: 99 }}
                  onClick={() => goBack()}
                >
                  <ArrowBackIcon sx={{ color: "#CF0000", fontSize: "30px" }} />
                </a>
              </div>
              <LogoContainer />
              <Routers />
            </Box>
          )}
        </ThemeProvider>
      </div>
    );
  } else if (window.location.href.split("/")[3] === "forget-message") {
    return <Routers />;
  } else {
    return (
      <div className={styles.App}>
        <ThemeProvider theme={theme}>
          <Box className={styles.appBox}>
            <div className={styles.headerContainer}>
              <a
                style={{ cursor: "pointer", zIndex: 99 }}
                onClick={() => goBack()}
              >
                <ArrowBackIcon sx={{ color: "#CF0000", fontSize: "30px" }} />
              </a>
              {pathLocation.pathname === "/login-phone" && (
                <Typography className={styles.titleHeader}>
                  Masukan Nomor Telepon
                </Typography>
              )}
              {pathLocation.pathname === "/send-method" && (
                <Typography className={styles.titleHeader}>
                  Verifikasi
                </Typography>
              )}
              {pathLocation.pathname === "/verify-otp" && (
                <Typography className={styles.titleHeader}>
                  Verifikasi Nomor Ponsel
                </Typography>
              )}
              {pathLocation.pathname === "/add-resource" && (
                <Typography className={styles.titleHeader}>
                  Login with Grochat Account
                </Typography>
              )}
            </div>
            <LogoContainer />
            <Routers />
          </Box>
        </ThemeProvider>
      </div>
    );
  }
}

export default App;
